import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { MachineType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { MachineService } from '@services';
import UiValidators, { UI_MACHINE_NAME_MAX_LENGTH } from '@validators';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
var MachineModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MachineModalComponent, _super);
    function MachineModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this.isLicenseKeyReadonly = true;
        _this.MachineType = MachineType;
        _this._machineService = _this._injector.get(MachineService);
        _this._translateService = _this._injector.get(TranslateService);
        return _this;
    }
    MachineModalComponent.prototype.ngOnInit = function () {
        var type = this.context.additionalData.type;
        this.context.data.type = MachineType[type];
        this.isStandardMachine = type === MachineType.Standard;
        this.isNameReadonly = this.isStandardMachine && !this.context.isNewEntry;
        var titleKey = this.context.isNewEntry ?
            this.isStandardMachine ?
                'machine_modal_add_standard_title' :
                'machine_modal_add_template_title' :
            this.isStandardMachine ?
                'machine_modal_edit_standard_title' :
                'machine_modal_edit_template_title';
        this.modalTitle = this._translateService.instant(titleKey, {
            machineName: this.context.data.name,
        });
        this.form = this._injector.get(FormBuilder).group({
            'name': [
                this.context.data.name,
                Validators.compose([
                    UiValidators.required(),
                    Validators.maxLength(UI_MACHINE_NAME_MAX_LENGTH),
                ])
            ],
            'licenseKey': [
                this.context.data.licenseKey,
            ],
            'description': [
                this.context.data.description,
                Validators.maxLength(500),
            ],
        });
    };
    MachineModalComponent.prototype.clipboardCopied = function () {
        this._snack.success(this._translateService.instant('global_message_copied_clipboard'));
    };
    MachineModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.form.valid ||
            this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        var formValue = this.form.value;
        this.context.data.licenseKey = formValue.licenseKey;
        this.context.data.name = formValue.name;
        this.context.data.description = formValue.description;
        if (this.context.isNewEntry) {
            this._machineService.add(this.context.data)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () {
                return _this._dialogRef.close({
                    type: 1 /* Add */,
                });
            });
        }
        else {
            this._machineService.update(this.context.data.id, this.context.data)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () {
                return _this._dialogRef.close({
                    type: 2 /* Update */,
                });
            });
        }
    };
    return MachineModalComponent;
}(UiModalComponent));
export { MachineModalComponent };
